import React from "react";
import { useApp } from "context";
import { Box as MUIBox } from "@mui/material";

type Props = {
  sx?: any;
  variant?: "filled" | "outlined";
  title?: string;
  multiline?: boolean;
  children: React.ReactNode;
};

export const Box = (props: Props) => {
  const { theme } = useApp();

  const filledTitleSx = {
    color: theme.color.disabled.color,
    fontSize: theme.font.sm,
    marginLeft: "1rem",
  };

  const outlinedTitleSx = {
    backgroundColor: theme.palette.background.accent,
    display: "inline-block",
    marginLeft: "0.75rem",
    paddingLeft: "0.25rem",
    paddingRight: "0.25rem",
    transform: "translateY(0.5rem)",
    zIndex: "1",
  };

  const multilineSx = {
    height: "initial",
    minHeight: "3.5rem",
    paddingTop: "1rem",
    paddingBottom: "1rem",
  };

  const outlinedSx = {
    border: "1px solid " + theme.palette.font.color,
    borderRadius: "16px",
    padding: "1rem",
  };

  const sx = {
    backgroundColor:
      props.variant === "filled"
        ? theme.palette.background.color
        : theme.palette.background.accent,
    borderRadius: "16px",
    display: "flex",
    alignItems: "center",
    height: "3.5rem",
    "& div": { marginLeft: "1rem", marginRight: "1rem" },
    "& .service-icon": { marginLeft: "0.5rem", marginRight: "0.5rem" },
    "& .MuiSvgIcon-root": { color: theme.palette.font.color },
    ...(props.multiline && multilineSx),
  };

  return (
    <>
      {props.title && props.variant && (
        <MUIBox
          component="div"
          sx={props.variant === "filled" ? filledTitleSx : outlinedTitleSx}
        >
          {props.title}
        </MUIBox>
      )}
      <MUIBox
        component="div"
        sx={{
          ...(props.variant === "outlined" ? outlinedSx : sx),
          ...props.sx,
        }}
      >
        {props.children}
      </MUIBox>
    </>
  );
};
